import React, { useEffect, useState } from 'react';
import Sheet from '../ui/Sheet';
import Icon from '../ui/Icon';
import API from '../../services/api';
import './LearningTipsSheet.css';

// Concept -> what to teach, not just what to ask (audit Parts 14-19). Every section type a topic could have; a topic
// simply omits whichever ones don't genuinely apply to it (Part 16) — this map only decides how a section LOOKS,
// never which ones exist for a given topic (that's entirely GET /questions/topics/:id/learning-content's answer).
const SECTION_META = {
  concept: { icon: 'book', label: 'Concept' },
  recognition: { icon: 'search', label: 'How to recognize it' },
  approach: { icon: 'flag', label: 'Approach' },
  method: { icon: 'list', label: 'Method' },
  shortcut: { icon: 'lightning', label: 'Shortcut' },
  common_mistake: { icon: 'warning', label: 'Common mistake' },
  calculation_focus: { icon: 'chart', label: 'What to calculate first' },
  example: { icon: 'edit', label: 'Worked example' },
};

// Bottom sheet showing one topic's authored learning content, with a "Practice" action that hands off to whatever
// the caller's own practice-start flow already is (this component never starts a session itself).
const LearningTipsSheet = ({ topicId, topicName, onClose, onPractice }) => {
  const [sections, setSections] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setSections(null); setError('');
    API.get(`/questions/topics/${topicId}/learning-content`)
      .then(res => { if (!cancelled) setSections(res.data.sections || []); })
      .catch(() => { if (!cancelled) setError('Could not load tips right now.'); });
    return () => { cancelled = true; };
  }, [topicId]);

  return (
    <Sheet
      open
      onClose={onClose}
      label={`${topicName} learning tips`}
      footer={onPractice && (
        <button type="button" className="z-btn z-btn--primary z-btn--block" onClick={onPractice}>
          Practice {topicName}
        </button>
      )}
    >
      <div className="lts-content">
        <span className="lts-eyebrow"><Icon name="tip" size={14} /> Quick Learning</span>
        <h2 className="lts-title">{topicName}</h2>

        {error && <p className="lts-empty">{error}</p>}
        {!error && sections === null && <p className="lts-empty">Loading…</p>}
        {!error && sections?.length === 0 && (
          <p className="lts-empty">No written tips for this topic yet — practice below to build real evidence.</p>
        )}
        {sections?.map(s => {
          const meta = SECTION_META[s.section_type] || { icon: 'tip', label: s.section_type };
          return (
            <div className="lts-section" key={s.id}>
              <span className="lts-section-head"><Icon name={meta.icon} size={16} />{s.title || meta.label}</span>
              <p className="lts-section-body">{s.body}</p>
            </div>
          );
        })}
      </div>
    </Sheet>
  );
};

export default LearningTipsSheet;
